define((require) => {
    "use strict";

    const EditorEvents            = require("shared/services/EditorEvents");
    const FilteringCollectionView = require("zbone/FilteringCollectionView");
    const NoResultsItemView       = require("zbone/NoResultsItemView");
    const Permissions             = require("shared/security/Permissions");
    const ProjectItemView         = require("ui/projects/ProjectItemView");
    const Storage                 = require("shared/services/Storage");

    /**
     * View for all projects.
     *
     * @cfg {ProjectCollection} collection
     *
     * @class ProjectCollectionView
     */
    return FilteringCollectionView.extend({

        className: "project-selector zmags-section wide",

        itemView: ProjectItemView,

        noResultsItemView() {
            return new NoResultsItemView({type: "Projects"});
        },

        itemViewOptions() {
            return {
                cannotDelete: Permissions.Privileges.CREATE.cannot()
            };
        },

        itemEvents: {
            "delete:project": "_deleteProjectHandler",
            "select:project": "_selectProjectHandler"
        },

        filterAttributeList: ["name", "id"],

        collectionName: Storage.Keys.PROJECT_COLLECTION,

        sortAttributeList: {
            lastUpdate: {
                label: "Last Updated",
                value: "editedAt",
                ascending: false
            },
            alphabetical: {
                label: "Alphabetical",
                value: "name",
                ascending: true
            },
            lastCreate: {
                label: "Last Created",
                value: "createdAt",
                ascending: false
            }
        },

        initialize() {
            this.options.filterDropdown = false;

            // Update sorting when projects have been updated/synced
            this.listenTo(this.collection, "change", function() {
                this.updateSort();
            });
        },

        onRender() {
            this.__super();

            if (Permissions.Privileges.CREATE.can()) {
                this._addCreateField();
            }
        },

        /**
         * Add a "create-project" button to the view.
         * Since the view is an abstract view, we need to do this in jquery.
         */
        _addCreateField() {
            this.$el.addClass("has-creation-field");
            this.$el.find(".collection").before("<a class='create-project-field' href='#project/create'>" +
                "<div class='text'>Create<br> New Project<br> &#43;</div></a>");
        },

        // TODO: Move below "handler" logic to view controller?

        _deleteProjectHandler(type, view, options) {
            const projectModel = options.model;

            if (Permissions.Privileges.CREATE.can() &&
                    confirm(`Are you sure you want to delete the Project, '${projectModel.get("name")}'?\n\n` +
                        `No Experiences, Images or Slots will be deleted.`)) {
                const eventProperties = {
                    projectId: projectModel.get("id"),
                    triggerOrigin: "DeleteProjectButton"
                };

                EditorEvents.trigger(EditorEvents.constants.DELETE_PROJECT, eventProperties);

                projectModel.destroy({source: "projectSelector"});
            }
        },

        _selectProjectHandler(type, view, options) {
            const eventProperties = {
                projectId: options.model.get("id"),
                dashboardType: "Experiences",
                triggerOrigin: "ProjectThumbnail"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_DASHBOARD, eventProperties);

            this.viewScope.toggleProjectSelector(false);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/ProjectCollectionView.js